export default {
    updateBiodivScore: false,
    cdfQuiz: null,
    cdfAnswers: null,
    usageFeedbacks: []
}
